import styled from 'styled-components';

export const Container = styled.div`
  margin: 30px 1px;
`;

export const Scale = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Button = styled.div`
  height: 8px;
  width: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) => (props.deactivated ? '#cce6ee' : '#0384ac')};

  ${(props) =>
    props.active &&
    `height: 16px;
  width: 16px;
  position: absolute;
  background-color: #fff;
  border: 3px solid #0384ac;
  border-radius: 8px;`}
`;

export const Ligature = styled.div`
  flex: 1;
  height: 2px;
  background-color: ${(props) => (props.deactivated ? '#cce6ee' : '#0384ac')};
`;

export const Text = styled.p`
  height: 16px;
  width: 16px;
  font-size: 14px;
  margin-top: 30px;
  text-align: center;
  color: #0384ac;
`;
